export const scheduling = {
  // ── Learner schedule page (schedule/page.tsx) ──
  // Header
  title: 'Send Your Preferred Lesson Times',
  back: 'Back to My Page',
  timezoneLabel: 'Time Zone',
  timezoneHint: '(Enter times in your local time)',

  // Self-apply form (student_driven / individual)
  choiceLabel: 'Choice #{{n}}',
  required: 'Required',
  optional: 'Optional',
  dateLabel: 'Date',
  timeLabel: 'Time',
  timePlaceholder: 'Select',
  submit: 'Send Preferred Times',
  submitting: 'Sending...',
  formNote: 'After you submit, the operator will coordinate scheduling with your partner. We will email you once it is confirmed.',

  // Validation
  errorFirstRequired: 'The date and time for your 1st choice are required',
  errorPairBoth: 'Please enter both a date and a time for choice #{{n}}',
  errorCreateFailed: 'Failed to create the request',

  // Done
  doneTitle: 'Sent!',
  doneMessage: 'We have received your preferred times.\nOnce the operator reviews them, we will email you a Google Meet link.',
  toMyPage: 'Go to My Page',

  // Loading
  loading: 'Loading...',

  // ── manager_driven view (organization coordinates scheduling) ──
  managerDrivenTitle: 'Your organization handles scheduling',
  managerDrivenMessage: 'The administrator of your organization will coordinate the schedule. We will email you once it is confirmed, so please wait a moment.',
  managerDrivenNote: 'If you have any questions, please contact your organization administrator.',

  // ── Organization manager view (org/schedule/page.tsx) ──
  orgTitle: 'Members\' Preferred Times',
  orgSubtitle: 'A list of preferred lesson times submitted by your organization members.',
  orgBack: 'Back to My Page',
  orgMemberLabel: 'Member',
  orgSlotsLabel: 'Preferred Times',
  orgStatusLabel: 'Status',
  orgChoice: 'Choice #{{n}}',
  orgEmpty: 'There are no preferred times to display at this time.',
  orgNoAccessTitle: 'Could not load preferred times',
  orgNoAccessMessage: 'Due to permission settings, member preferred times may not be directly accessible. Please ask an administrator (admin) to confirm scheduling.',
  orgLoadError: 'Failed to load. Please try again later.',
  retry: 'Reload',

  // Status labels
  statusPending: 'Awaiting coordination',
  statusConfirmed: 'Confirmed',
  statusOther: 'Other',
};
